import { GatewayI } from '../interfaces/gateway.interface'
import { GatewayService } from '../services/gateway.service'
import {
    CreateClientPayloadT,
    CreateMicroservicePayloadT,
    CreatePermissionPayloadT,
    CreateRolePayloadT,
    GatewayGetClientsResponseT,
    GatewayGetMicroservicesResponseT,
    GatewayGetPermissionsResponseT,
    GatewayGetRolesResponseT,
    GatewayGetScopeRoutesResponseT,
    GatewayGetScopesResponseT,
    GatewayGetRoutesResponseT,
    GatewayRouteT,
    GatewayGetScopesParamsT,
    GatewayGetRoutesParamsT,
    RolesListParamsT,
    ClientsListParamsT,
    MicroservicesListParamsT,
    GatewayGenerateTokenResponseT,
} from '../types/gateway.types'

const gatewayService = new GatewayService()

class GatewayRealisation implements GatewayI {
    getRoles(page: number, payload?: RolesListParamsT): Promise<GatewayGetRolesResponseT> {
        return gatewayService.getRoles(page, payload)
    }

    getPermissions(
        page: number,
        name?: string,
        serviceId?: string
    ): Promise<GatewayGetPermissionsResponseT> {
        return gatewayService.getPermissions(page, name, serviceId)
    }

    getMicroservices(
        page: number,
        search?: string,
        payload?: MicroservicesListParamsT
    ): Promise<GatewayGetMicroservicesResponseT> {
        return gatewayService.getMicroservices(page, search, payload)
    }

    getScopes(page: number, params?: GatewayGetScopesParamsT): Promise<GatewayGetScopesResponseT> {
        return gatewayService.getScopes(page, params)
    }

    getRoutes(page: number, params?: GatewayGetRoutesParamsT): Promise<GatewayGetRoutesResponseT> {
        return gatewayService.getRoutes(page, params)
    }

    getScopeRoutes(scope_id: number, page: number): Promise<GatewayGetScopeRoutesResponseT> {
        return gatewayService.getScopeRoutes(scope_id, page)
    }

    linkRoute(scope_id: number, route_id: number): Promise<void> {
        return gatewayService.linkRoute(scope_id, route_id)
    }

    unlinkRoute(scope_id: number, route_id: number): Promise<void> {
        return gatewayService.unlinkRoute(scope_id, route_id)
    }

    createScope(scope: string, description: string, isActive: boolean) {
        return gatewayService.createScope(scope, description, isActive)
    }

    createRoute(route: GatewayRouteT) {
        return gatewayService.createRoute(route)
    }

    updateScope(scope_id: number, scope: string, description: string, isActive: boolean) {
        return gatewayService.updateScope(scope_id, scope, description, isActive)
    }

    createMicroservice(payload: CreateMicroservicePayloadT): Promise<void> {
        return gatewayService.createMicroservice(payload)
    }

    updateMicroservice(
        microservice_id: number,
        payload: CreateMicroservicePayloadT
    ): Promise<void> {
        return gatewayService.updateMicroservice(microservice_id, payload)
    }

    importAllRoutes(): Promise<void> {
        return gatewayService.importAllRoutes()
    }

    importMicroserviceRoutes(microservice_id: number): Promise<void> {
        return gatewayService.importMicroserviceRoutes(microservice_id)
    }

    createPermission(payload: CreatePermissionPayloadT): Promise<void> {
        return gatewayService.createPermission(payload)
    }

    updatePermission(permission_id: number, payload: CreatePermissionPayloadT): Promise<void> {
        return gatewayService.updatePermission(permission_id, payload)
    }

    createRole(payload: CreateRolePayloadT): Promise<void> {
        return gatewayService.createRole(payload)
    }

    updateRole(role_id: number, payload: CreateRolePayloadT): Promise<void> {
        return gatewayService.updateRole(role_id, payload)
    }

    updateRoute(route: GatewayRouteT): Promise<void> {
        return gatewayService.updateRoute(route)
    }

    deleteRole(role_id: number): Promise<void> {
        return gatewayService.deleteRole(role_id)
    }

    deleteRoute(route_id: number): Promise<void> {
        return gatewayService.deleteRoute(route_id)
    }

    getClients(page: number, payload?: ClientsListParamsT): Promise<GatewayGetClientsResponseT> {
        return gatewayService.getClients(page, payload)
    }

    createClient(payload: CreateClientPayloadT): Promise<void> {
        return gatewayService.createClient(payload)
    }

    updateClient(client_id: number, payload: CreateClientPayloadT): Promise<void> {
        return gatewayService.updateClient(client_id, payload)
    }

    deleteClient(client_id: number): Promise<void> {
        return gatewayService.deleteClient(client_id)
    }

    deletePermission(id: number): Promise<void> {
        return gatewayService.deletePermission(id)
    }

    generateToken(user_id: number, client_id: number): Promise<GatewayGenerateTokenResponseT> {
        return gatewayService.generateToken(user_id, client_id)
    }
}

export const gateway = new GatewayRealisation()
